import { Helmet } from "react-helmet";
import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import "../src/assets/css/style.css";
import constants from "./constants.json";
import logo_img from "../src/assets/images/main-img.svg";
import Axios from "axios";

const { navs, page1, page2 } = constants;

const Marker = (props) => (
  <div className="marker" title={props.title} >
    <img src="/assets/images/marker.png" alt="ania-management" width="25" height="25" />
  </div>
);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: null,
      center: {
        lat: 40.90565717544739,
        lng: -74.16857382416788,
      },
      zoom: 11,
      formValues : {
        name: "",
        email: "",
        phone: "",
        bedCount: "",
        message: ""
      },
      showError: false
    };
  }

  static getDerivedStateFromProps(){
    return { activePage: page2 }
  }

  handleApiLoaded = (map, maps) => {
    new maps.Marker({
      position: { lat: this.state.center.lat, lng: this.state.center.lng },
      // map,
      title: "Ania Management",
    });
  };

  render() {
    const { activePage: { banner_wrap, address, oneBedRoom, twoBedRoom, project, floor, neighborhood, locations, projectListLeft, projectListRight } } = this.state;
    
    const handleSubmit = async (e) => {
      e.preventDefault();
      this.setState({showError: true});
      let { name, email, phone, bedCount, message } = this.state.formValues;
      if (
        !name ||
        !email ||
        // !phone ||
        // !bedCount ||
        !message
      ) {
        return;
      }

      try {

        let payload = {
          bedroom: this.state.formValues.bedCount,
          content: this.state.formValues.message,
          email: this.state.formValues.email,
          fullName: this.state.formValues.name,
          phone: this.state.formValues.phone,
          propertyAddress: "216 spring st, Paterson, NJ 07503",
          subject: "Property Inquiry: 216 spring st, Paterson, NJ 07503"
        };

        console.log(payload);

        const response = await Axios.post("https://apidev.floriomanagement.com/api/unit_property/rentalInquiry", payload, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        });

        if (response && response.status === 200) {
          alert("Inquiry added successfully");
        }

      } catch(error) {
        console.log(error);
      }
    };

    return (
      <div className="App">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{address.street}</title>
          <link rel="canonical" href="http://localhost:3000" />
        </Helmet>
        <header className="wrapper">
          <h1 hidden={true}>{address.street}</h1>
          <nav className="custom-container">
            <div className="row-wrapper px-2">
              <div className="row-con">
                <div className="col-nav-con-1">
                  <div className="nav-logo-con">
                  <a href="https://www.aniamanagement.com/" target="_self">
                    <img
                      className="site-logo"
                      src={logo_img}
                      alt="ania-management"
                      srcSet=""
                    />
                    </a>
                  </div>
                </div>
                <div className="col-nav-con-1">
                  <div className="social-con">
                    <ul className="social-menu">
                      <li>
                        <a target="_blank" rel="noreferrer noopener" href="https://www.facebook.com/AniaGroup">
                          <img src="/assets/images/Facebook.png" width="30" alt="facebook" srcSet="" />
                        </a>
                      </li>
                      <li>
                        <a target="_blank" rel="noreferrer noopener" href="https://www.instagram.com/AniaGroup/">
                          <img src="/assets/images/instagram.png" width="30" alt="instagram" srcSet="" />
                        </a>
                      </li>
                      <li>
                        <a target="_blank" rel="noreferrer noopener" href="https://www.linkedin.com/company/aniagroup">
                          <img src="/assets/images/LinkedIn.png" width="30" alt="linkedin" srcSet="" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </nav>

          <nav class="navbar navbar-expand-lg blue-nav-bar ">
            <span class="navbar-brand"></span>
            <button class="navbar-toggler m-nav-btn navbar-dark" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse custom-container nav-mwrap" id="navbarSupportedContent">
              <div className="nav-wrapper">
                <ul class="navbar-nav nav-items-con">
                  {navs.map((item, i) => (
                    <li key={i} className="nav-menu-items">
                      <a className='nav-link' href={item.link}>{item.name}</a>
                    </li>
                  ))}
                </ul>
              </div>

            </div>
          </nav>
          
          <div className="banner-wrap" style={{ backgroundImage: `url(${banner_wrap})`}}>
            <div className="overlay-wrapper-outer">
              <div className="custom-container">
                <div className="overlay-wrapper">
                  <div className="overlay-row d-flex">
                    <div className="over-lay-col-1">
                      <div className="overlay-col-con-1">
                        <h3 className="high-light-title">{address.street}</h3>
                        <p className="reg-text-sub">{address.state}</p>
                      </div>
                    </div>
                    <div className="over-lay-col-2">
                      <div className="overlay-col-con-1">
                        <p className="reg-text-sub pb-4">
                          ONE<br />BEDROOM
                        </p>
                        <p className="reg-text-sub">
                          TWO<br />BEDROOM
                        </p>
                      </div>
                    </div>

                    <div className="over-lay-col-2">
                      <div className="overlay-col-con-1 pb-3">
                        <p className="reg-text-sub">Starting from</p>
                        <p className="price-tag">{oneBedRoom.price}</p>
                      </div>
                      <div className="overlay-col-con-1">
                        <p className="reg-text-sub">Starting from</p>
                        <p className="price-tag">{twoBedRoom.price}</p>
                      </div>
                    </div>

                    <div className="over-lay-col-2">
                      <div className="overlay-col-con-1">
                        <p className="reg-text-sub pb-4">
                        {oneBedRoom.area}<br />1 Bathroom / 1 Parking
                        </p>
                        <p className="reg-text-sub">
                        {twoBedRoom.area}<br />1 Bathroom / 1 Parking
                        </p>
                      </div>
                    </div>
                    <div className="over-lay-col-3">
                      <div className="overlay-col-con-1">
                        <a href="#floor">
                          VIEW FLOOR<br />PLANS
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>


        <section className="over-lay-wrap">
          <div className="overlay-wrapper-outer-m">
            <div className="custom-container">
              <div className="overlay-wrapper pl-0 text-center">
                <div className="overlay-row m-overlay d-flex">
                  <div className="over-lay-col-full">
                    <div className="overlay-col-con-1 py-4">
                      <h3 className="high-light-title">{address.street}</h3>
                      <p className="reg-text-sub sub-mobile">{address.state}</p>
                    </div>
                  </div>
                  <div className="over-lay-col-full">
                    <div className="overlay-col-con-1 row no-gutters justify-content-around">
                      <div className="over-m-col col-md-6 col-sm-12 d-flex justify-content-around">
                        <p className="reg-text-sub pb-2 text-left">
                          ONE<br />BEDROOM
                        </p>
                        <div className="overlay-col-con-1 pb-4 text-left">
                          <p className="reg-text-sub pb-1">Starting from</p>
                          <p className="price-tag pb-1">{oneBedRoom.price}</p>
                          <p className="reg-text-sub pb-1">
                          {oneBedRoom.area}<br />1 Bathroom / 1 Parking
                        </p>
                        </div>
                      </div>
                      <div className="over-m-col col-md-6 col-sm-12 d-flex justify-content-around">
                        <p className="reg-text-sub pb-2 text-left">
                          TWO<br />BEDROOM
                        </p>
                        <div className="overlay-col-con-1 pb-4 text-left">
                          <p className="reg-text-sub pb-1">Starting from</p>
                          <p className="price-tag pb-1">{twoBedRoom.price}</p>
                          <p className="reg-text-sub pb-1">
                          {twoBedRoom.area}<br />1 Bathroom / 1 Parking
                        </p>
                        </div>
                      </div>
                    </div>
                  </div>



                  <div className="over-lay-col-full">
                    <div className="overlay-col-con-1 over-m-btn">
                      <a href="#floor">
                        VIEW FLOOR<br />PLANS
                        </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="wrapper" id="project">
          <div className="custom-container">
            <div className="content-con">
              <h3 className="prime-title">
                PROJECT <span className="blue-head">HIGHLIGHTS</span>
              </h3>
              <div className="content-inner prime-content text-left">
                <p className="mb-0">
                  {project.highlight[0]}
                </p>
                <br />
                <p className="mb-0">
                  {project.highlight[1]}
                </p>
                <br />
                <p className="mb-0">
                  {project.highlight[2]}
                </p>
                <div className="list-con">
                  <div className="list-title-con">
                    <h5>Features</h5>
                  </div>
                  <div className="list-row-wrap">
                    <div className="list-row w-100 d-flex">
                      <div className="list-col">
                        <div className="list-inner">
                          <ul className="project-list">
                            {
                              projectListLeft.map((item, i) => (
                                <li key={i} className="projetc-list-item">
                                  <span>
                                    <img
                                      className="mr-2"
                                      src="/assets/images/blue-tick.png"
                                      alt="alt-img"
                                      srcSet=""
                                    />
                                    {item.name}
                                  </span>
                                </li>
                              ))
                            }
                          </ul>
                        </div>
                      </div>
                      <div className="list-col list-col-rhs">
                        <div className="list-inner">
                          <ul className="project-list">
                            {
                              projectListRight.map((item, i) => (
                                <li key={i} className="projetc-list-item">
                                  <span>
                                    <img
                                      className="mr-2"
                                      src="/assets/images/blue-tick.png"
                                      alt="alt-img"
                                      srcSet=""
                                    />
                                    {item.name}
                                  </span>
                                </li>
                              ))
                            }
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="wrapper light-bcolor" id="floor">
          <div className="custom-container">
            <div className="floor-plan-section text-center">
              <h3 className="prime-title pl-4">
                FLOOR <span className="blue-head">PLANS</span>
              </h3>
              <div className="gallery-content pb-5">
                <p>
                  {floor.content}
                </p>
              </div>
              <div className="floor-con">
                <div className="floor-row d-flex justify-content-center">
                  <div className="floor-col">
                    <h5 className="plan-sub-title">One Bedroom</h5>
                    <div className="plan-img padd">
                      <img
                        className="image-fluid"
                        src={floor.oneBedroom}
                        alt="alt-img"
                      />
                    </div>
                  </div>
                  <div className="floor-col">
                    <h5 className="plan-sub-title">Two Bedroom</h5>
                    <div className="plan-img">
                      <img
                        className="image-fluid"
                        src={floor.twoBedroom}
                        alt="alt-img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="wrapper" id="gallery">
          <div className="custom-container">
            <div className="gallery-wrapper">
              <h3 className="photo-gallery-title">
                PHOTO <span className="blue-head">GALLERY</span>
              </h3>
            </div>
          </div>
          <div className="galler-img-wrap">
            <div className="gallery-img-row d-flex w-100">
              {[1, 2].map((num) => (
                <div key={num} className="gallet-img-col">
                  <div className={`col-gal-inner ${neighborhood.title[0] === "THE" ? 'gallery' : 'gal'}-${num}`}></div>
                </div>
              ))}
            </div>
            <div className="gallery-img-row d-flex w-100">
              {[3, 4].map((num) => (
                <div key={num} className="gallet-img-col">
                  <div className={`col-gal-inner ${neighborhood.title[0] === "THE" ? 'gallery' : 'gal'}-${num}`}></div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="wrapper">
          <div className="custom-container">
            <div className="gallery-wrapper">
              <h3 className="prime-title text-center pl-4">
              {neighborhood.title[0]} <span className="blue-head">{neighborhood.title[1]}</span>
              </h3>
              <div className="gallery-content">
                <p>
                  {neighborhood.content}
                </p>
              </div>
            </div>
          </div>

          <div className="near-by-img-wrapper">
            <div className="near-row">
              {locations.map((item, i) => (
                <div className="near-col" key={i}>
                  <div className="near-col-wrap2">
                    <a
                      // eslint-disable-next-line no-script-url
                      target={item.link === "javascript:void(0)" ? "" : "_blank"}
                      rel="noreferrer noopener"
                      href={item.link}
                    >
                      <img src={item.src} alt="alt-img" />
                    </a>
                    <div className="near-label py-2 w-100">
                      <span className="pl-2">{item.name}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="map-wrap w-100">
            <div className="map-con">
              <GoogleMapReact
                bootstrapURLKeys={{
                  key: process.env.REACT_APP_GOOGLE_MAP_KEY,
                }}
                defaultCenter={this.state.center}
                defaultZoom={this.state.zoom}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({ map, maps }) =>
                  this.handleApiLoaded(map, maps)
                }
              >
                <Marker
                  lat={this.state.center.lat}
                  lng={this.state.center.lng}
                  name="Ania Management"
                />
              </GoogleMapReact>
            </div>
          </div>
        </section>

        {/* <section id="how" className="wrappper blue-bg-color">
          <div className="custom-container text-center">
            <div className="how-to-con">
              <h5 className="how-to-title">HOW TO APPLY</h5>
              <div className="how-content">
                <p>
                  To apply, visit our office at: 175 Broadway, Paterson, NJ
                  <br />
                  For more information, call: 973-523-7690
                </p>
              </div>
            </div>
          </div>
        </section> */}
        
        <section id="inquiry" className="wrappper"  style={{margin: "0px 15px" }}>
          <div className="custom-container form">
            <div className="row">
              <div className="col-sm-12">
                <div className="box">
                  <div className="text-center">
                    <h6>Connect with a Rental Agent</h6>
                  </div>
                    <div className="center">
                    <div className="input-tag"><input type="text" 
                        required
                        className={`${this.state.showError && !this.state.formValues.name ? 'input-invalid' : ''}`}
                        placeholder="Name *" 
                        value={this.state.formValues.name} 
                        onChange={(e) => this.setState({formValues : {...this.state.formValues, name: e.target.value }})}
                      />
                      {this.state.showError && !this.state.formValues.name && <p className="error-msg">
                        Name is required
                      </p>}
                      </div>
                      <div className="input-tag"><input type="text" 
                        required
                        className={`${this.state.showError && !this.state.formValues.email ? 'input-invalid' : ''}`}
                        placeholder="Email Address *"
                        value={this.state.formValues.email} 
                        onChange={(e) => this.setState({formValues : {...this.state.formValues, email: e.target.value }})}
                      />
                      {this.state.showError && !this.state.formValues.email && <p className="error-msg">
                        Email is required
                      </p>}
                      </div>
                      <div className="middle">
                      <div>
                        <input type="text" 
                          required
                          // className={`${this.state.showError && !this.state.formValues.phone ? 'input-invalid' : ''}`}
                          className=""
                          placeholder="Phone Number"
                          value={this.state.formValues.phone} 
                          maxLength={10}
                          onChange={(e) => this.setState({formValues : {...this.state.formValues, phone: e.target.value.replace(/[^0-9]/g, "" )}})}
                        />
                        {/* {this.state.showError && !this.state.formValues.phone && <p className="error-msg">
                          Phone is required
                        </p>} */}
                        </div>
                        <div>
                        <input type="text" 
                          required
                          // className={`${this.state.showError && !this.state.formValues.bedCount ? 'input-invalid' : ''}`}
                          className=""
                          placeholder="Bedroom Count"
                          value={this.state.formValues.bedCount} 
                          maxLength={1}
                          onChange={(e) => this.setState({formValues : {...this.state.formValues, bedCount: e.target.value.replace(/[^0-9]/g, "" ) }})}
                        />
                        {/* {this.state.showError && !this.state.formValues.bedCount && <p className="error-msg">
                          Bedroom Count is required
                        </p>} */}
                        </div>
                      </div>
                      <div className="input-tag"><textarea rows="4" cols="50" 
                        required
                        className={`${this.state.showError && !this.state.formValues.message ? 'input-invalid' : ''}`}
                        placeholder="Message "
                        value={this.state.formValues.message} 
                        onChange={(e) => this.setState({formValues : {...this.state.formValues, message: e.target.value }})}
                      ></textarea>
                        {this.state.showError && !this.state.formValues.message && <p className="error-msg">
                          Message is required
                        </p>}
                      </div>
                      <button type="button" onClick={(e) => handleSubmit(e)}>Inquire</button>
                    </div>
                </div>
              </div>
              <div className="col-sm-12">
                <div className="text-center text">
                <p>For more information: Visit our office at 175 Broadway, Paterson, NJ or Call us at 973-523-7690</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <footer>
          <div className="footer-wrap text-center">
            <div className="social-con">
              <ul className="social-menu">
                <li>
                  <a target="_blank" rel="noreferrer noopener" href="https://www.facebook.com/AniaGroup">
                    <img src="/assets/images/Facebook.png" width="30" alt="facebook" srcSet="" />
                  </a>
                </li>
                <li>
                  <a target="_blank" rel="noreferrer noopener" href="https://www.instagram.com/AniaGroup/">
                    <img src="/assets/images/instagram.png" width="30" alt="instagram" srcSet="" />
                  </a>
                </li>
                <li>
                  <a target="_blank" rel="noreferrer noopener" href="https://www.linkedin.com/company/aniagroup">
                    <img src="/assets/images/LinkedIn.png" width="30" alt="linkedin" srcSet="" />
                  </a>
                </li>
              </ul>
            </div>
            <p className="mb-0 py-2">
              {new Date().getFullYear()} All Rights Reserved • ANIA Management
            </p>
          </div>
        </footer>
      </div >
    );
  }
}

export default App;
